import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { captureLeadEmail } from '../utils/captureLeadEmail';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const handleEmailBlur = () => {
    captureLeadEmail(email, window.location.pathname, { context: 'forgot_password' });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setStatus(null);
    setSubmitting(true);

    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/password-reset/request`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });
      const data = await res.json();
      if (!res.ok) {
        throw new Error(data?.error || 'Unable to request a reset link');
      }
      setStatus(data?.message || 'If an account exists for that email, a reset link has been sent.');
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="App-main forgot-page">
      <h2>Reset your password</h2>
      <p className="status-text forgot-center">Enter the email tied to your account and we’ll send a reset link.</p>
      <form onSubmit={handleSubmit} className="auth-form">
        {error && <p className="error-message">{error}</p>}
        {status && <p className="success-message">{status}</p>}
        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            onBlur={handleEmailBlur}
            required
          />
        </div>
        <button type="submit" className="primary-button" disabled={submitting}>
          {submitting ? 'Sending...' : 'Send reset link'}
        </button>
      </form>
      <p className="forgot-center" style={{ marginTop: '1rem' }}>
        Remembered it? <Link to="/login">Back to login</Link>
      </p>
    </main>
  );
}

export default ForgotPassword;
